<template>
    <div class="full-width-inputs" v-loading="loading">
        <div class="input-part">
            <div class="input-label">
                <span tkey="地區">{{i18n.tkey("lang_area_text")}}</span>
            </div>

            <div>
                <countrySelector v-model="dataObj.District1" :disabledValues="disabledCountryList" :useEmptyOption="true" ref="countrySelecterDom" />
            </div>
        </div>

        <div class="input-part">
            <div class="input-label">
                <span tkey="中文描述">{{i18n.tkey("lang_chinese_remark")}}</span>
            </div>

            <div>
                <el-input
                        type="text"
                        v-model="dataObj.ShipmentAddress"
                        placeholder=""
                        clearable
                        show-word-limit
                        maxlength="200"
                />
            </div>
        </div>

        <div class="input-part">
            <div class="input-label">
                <span tkey="英文描述">{{i18n.tkey("lang_english_remark")}}</span>
            </div>

            <div>
                <el-input
                        type="text"
                        v-model="dataObj.ShipmentAddressCN"
                        placeholder=""
                        clearable
                        show-word-limit
                        maxlength="200"
                />
            </div>
        </div>

        <div>
            <el-button type="primary" @click="clickAddBtn" v-if="null == editObj" tkey="提交">{{i18n.tkey("lang_submit")}}</el-button>
            <el-button type="primary" @click="clickSaveBtn" v-if="null != editObj" tkey="保存">{{i18n.tkey("lang_save")}}</el-button>
        </div>

    </div>
</template>

<script setup>
    import {inject, ref, onBeforeMount, onMounted, watch} from "vue";
    import countrySelector from "@/components/shopopee/country/countrySelector"
    import myUtil from "@/util/util";
    import eshopopeeApi from "@/request/eshopopeeApi";

    const props = defineProps(['editObj', "disabledCountryList"])
    const emits = defineEmits(['save-success'])

    const i18n = inject("i18n")
    const loading = ref(false)

    const dataObj = ref({
        District1: null,
        ShipmentAddress: "",
        ShipmentAddressCN: "",
    })

    const countrySelecterDom = ref(null)

    const { getShopCompanyObj } = inject('shopControlFunc', { getShopCompanyObj: () => { return {} } })

    const shopCompany = ref({})

    function clickAddBtn() {
        if (myUtil.isEmpty(dataObj.value.District1)){
            myUtil.alertWarning(i18n.tkey("lang_pls_select_region"))
            return
        }

        if (myUtil.isEmpty(dataObj.value.ShipmentAddress) || myUtil.isEmpty(dataObj.value.ShipmentAddressCN)){
            myUtil.alertWarning(i18n.tkey("lang_enter_complete"))
            return
        }

        const obj = generateSettingObj()

        addRecord(obj)
    }

    function clickSaveBtn(){
        if (myUtil.isEmpty(dataObj.value.District1)){
            myUtil.alertWarning(i18n.tkey("lang_pls_select_region"))
            return
        }

        if (myUtil.isEmpty(dataObj.value.ShipmentAddress) || myUtil.isEmpty(dataObj.value.ShipmentAddressCN)){
            myUtil.alertWarning(i18n.tkey("lang_enter_complete"))
            return
        }

        const regionObj = countrySelecterDom.value.getSelectObj()
        dataObj.value.CountryName = regionObj.countryname
        dataObj.value.CountryName2 = regionObj.countryname2

        updateRecord()
    }

    function generateSettingObj(){

        const regionObj = countrySelecterDom.value.getSelectObj()

        return {
            CompanyCode: shopCompany.value.acccompanycode,  //eshopopee公司代码
            District1: dataObj.value.District1,
            ShipmentAddress: dataObj.value.ShipmentAddress,
            ShipmentAddressCN: dataObj.value.ShipmentAddressCN,
            CountryName: regionObj.countryname,
            CountryName2: regionObj.countryname2
        }
    }

    function addRecord(obj){
        loading.value = true

        const request = eshopopeeApi.addDeliverynameRecord
        const params = request.getParams()

        params.ShipmentAddress = obj.ShipmentAddress
        params.ShipmentAddressCN = obj.ShipmentAddressCN
        params.District1 = obj.District1
        params.CompanyCode = shopCompany.value.acccompanycode

        request.send(params, (res) => {
            loading.value = false

            if (myUtil.isNotEmpty(res) && res.code == 200){
                myUtil.alertSuccess(i18n.tkey("lang_save_success"))
                emits("save-success")
            }else{
                myUtil.alertError(i18n.tkey("lang_request_error"))
            }

        })

    }

    function updateRecord(){
        loading.value = true

        const request = eshopopeeApi.updateDeliverynameRecord
        const params = request.getParams()

        params.ShipmentAddress = dataObj.value.ShipmentAddress
        params.ShipmentAddressCN = dataObj.value.ShipmentAddressCN
        params.District1 = dataObj.value.District1
        params.id = props.editObj.ID

        request.send(params, (res) => {
            loading.value = false

            if (res.code == 200){
                myUtil.alertSuccess(i18n.tkey("lang_save_success"))
                emits("save-success")
            }else{
                myUtil.alertError(i18n.tkey("lang_request_error"))
            }
        })

    }

    onBeforeMount(() => {

        if (null != props.editObj){
            dataObj.value = {
                Country: null,
                Cost: 0,
                BiggerThan: 0,
            }
            Object.assign(dataObj.value, props.editObj)
        }

    })

    onMounted(() => {
        shopCompany.value = getShopCompanyObj()
    })

</script>

<style scoped>
    .input-part {
        margin-bottom: 20px;
    }

    .input-label {
        margin-bottom: 5px;
        font-weight: 600;
        font-size: 12px;
    }

    .full-width-inputs {
        width: 100%;
        text-align: left;
        padding-top: 20px;
    }
</style>